import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useAsync } from '@sde/widgets-core/src/redux/hooks/useAsync';
import { userSSO } from './actions';
import { USER_SSO } from './constants';

export const useSSO = {
  actions: () => {
    return {
      userSSO: useAction(userSSO, {
        saga: useAsync(USER_SSO),
      }),
    };
  },
};
